import { z } from "zod";

import { catalogIdSchema } from "@garimpa/lib/catalogId";

export const addToListsTargetSchema = z.discriminatedUnion("entityType", [
  z.object({
    entityType: z.literal("work"),
    workId: catalogIdSchema,
  }),
  z.object({
    entityType: z.literal("release"),
    releaseId: catalogIdSchema,
    workId: catalogIdSchema,
  }),
]);

export type AddToListsTarget = z.infer<typeof addToListsTargetSchema>;

export function itemQueryForAddToListsTarget(target: AddToListsTarget) {
  if (target.entityType === "release") {
    return { releaseId: target.releaseId, workId: target.workId };
  }
  return { workId: target.workId };
}
